export enum Routes {
  FeedbackRouter = '/feedback',
}
